import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { brutRgbMainBlue, darkBlue } from 'utils/constants/ColorTheme'
import { LARGE_RADIUS, MAIN_RADIUS } from 'utils/constants/Theme'

const StyledFieldSet = styled('fieldset')({
    borderRadius: '5px',
    border: 'solid 1px grey',
    padding: '5 8',
    backgroundColor: 'white',
    margin: '10 0 0 0',
})

const SmallStyledFieldSet = styled('fieldset')({
    borderRadius: MAIN_RADIUS,
    border: 'solid 1px grey',
    padding: '0.5rem',
    backgroundColor: 'white',
    margin: 0,
})

const StyledLegend = styled('legend')({
    backgroundColor: 'white',
    border: 'solid 1px grey',
    borderRadius: '5px',
    padding: '0 10',
    color: darkBlue,
    fontWeight: 'bold',
})

const StyledSpan = styled('span')({
    lineheight: '12px',
    fontSize: '16px',
})

const FieldsetMUI = ({
    title,
    children,
    sx = {},
    ...props
}) => (
    <Box
        component='fieldset'
        sx={{
            border: 'solid 1px',
            borderColor: `rgba(${brutRgbMainBlue}, 0.4)`,
            borderRadius: LARGE_RADIUS,
            ...sx,
        }}
        {...props}
    >
        {title && (
            <Typography
                component='legend'
                variant='legend'
            >
                {title}
            </Typography>
        )}
        {children}
    </Box>
)

FieldsetMUI.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    children: PropTypes.element.isRequired,
    sx: PropTypes.shape({}),
}

const FieldsetTreatmentMUI = ({
    title,
    children,
    sx = {},
    ...props
}) => (
    <Box
        component='fieldset'
        sx={{
            border: 'solid 1px',
            borderColor: `#C0C0C0`,
            borderRadius: 0,
            ...sx,
        }}
        {...props}
    >
        {title && (
            <Typography
                component='legend'
                variant='legend'
            >
                {title}
            </Typography>
        )}
        {children}
    </Box>
)

FieldsetMUI.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    children: PropTypes.element.isRequired,
    sx: PropTypes.shape({}),
}

export { StyledFieldSet, SmallStyledFieldSet, StyledLegend, StyledSpan, FieldsetMUI, FieldsetTreatmentMUI }